import React from 'react';
import { safeHtml } from '../shared/utilities';
import { SectionHeadingProps } from '../types';
function SectionBody(props: SectionHeadingProps) {
  return <p>{safeHtml(props.Heading)}</p>;
}
export default SectionBody;
